import './Drones.css';
import { useTranslation } from "react-i18next";
import { ModemData } from '../../api/Drone';
import { ReactNode } from 'react';
import firmware from '../../utils/firmware';

interface ModemMainPProps {
    drone: ModemData;
}

function ModemMainP({ drone }: ModemMainPProps): ReactNode {
    const { t } = useTranslation(['modem']);

    return (
        <>
            {drone == null ? (
                <p>{t('modem_not_found')}</p>
            ) : (
                <>
                    <div className='t-big ts-16'>{drone.name}</div>
                    <div className='t-14'>IMEI: {drone.imei}</div>
                    <div className='t-14'>{t('firmware_version')}: {firmware.normalizeFirmwareVersion(drone.firmwareVersion, drone.version)}</div>
                </>
            )}
        </>
    )
}

export default ModemMainP;